var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"inline-block",attrs:{"href":_vm.url,"target":"_blank","aria-label":_vm.type}},[_c('object',{staticClass:"inline-block",class:_vm.small ? 'w-5 h-5' : 'w-7 h-7',style:(_vm.nonFilterable
                ? 'filter: none'
                : _vm.white
                ? 'filter: invert(99%) sepia(24%) saturate(275%) hue-rotate(190deg) brightness(110%) contrast(101%)'
                : ''),attrs:{"tabindex":"-1","aria-label":`${_vm.type} icon`,"type":"image/svg+xml","data":require(`~/assets/images/icons/${_vm.type}.svg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }